import Vue from "vue";
import Vuex from "vuex";

import broadcast from "./modules/broadcast";
import CurrencyApi from "@/api/CurrencyApi";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userName: null,
    userImageUrl: null,
    // 사용자 국가(ISO 3166-1 alpha-2). user_account.country_code 미러. 언어는 $i18n.locale가 SSOT.
    userCountryCode: null,
    virtupetName: null,
    currentModelIndex: null,
    expiredAt: null,

    // 활성(선택) 펫 id — user_status.selected_pet_id 미러. 부트스트랩·펫선택·온보딩완료 시 갱신.
    selectedPetId: null,

    // 관리자 여부 — session.user.app_metadata.is_admin 미러. 부트스트랩 시 1회 세팅.
    isAdmin: false,

    // 팬 여부 — 현재 활성 공간이 팬인지. 사이드바(스트리머/팬) 분기용.
    isFan: false,

    // 활성 펫 변경 신호 — 펫 선택 시 bump → 사이드바 등이 watch해 재로드.
    petRevision: 0,

    // 재화 잔액 — 중앙 관리. 표시는 사이드바 등에서 구독. (UI는 🥕로 표기)
    currencyBalance: 0,

    // REACTIONS (통합 reaction 테이블 — 셀렉터/리졸버용). { byId, bySlug, list }
    reactions: { byId: {}, bySlug: {}, list: [] },
  },
  getters: {},
  mutations: {
    __setCurrencyBalance(state, balance) {
      state.currencyBalance = Number(balance) || 0;
    },
    __setUserName(state, name) {
      state.userName = name;
    },
    __setUserImageUrl(state, imageUrl) {
      state.userImageUrl = imageUrl;
    },
    __setUserCountryCode(state, countryCode) {
      state.userCountryCode = countryCode;
    },
    __setVirtupetName(state, name) {
      state.virtupetName = name;
    },
    __bumpPetRevision(state) {
      state.petRevision++;
    },
    __setCurrentModelIndex(state, currentModelIndex) {
      state.currentModelIndex = currentModelIndex;
    },
    __setSelectedPetId(state, petId) {
      state.selectedPetId = petId;
    },
    __setIsAdmin(state, isAdmin) {
      state.isAdmin = Boolean(isAdmin);
    },
    __setIsFan(state, isFan) {
      state.isFan = Boolean(isFan);
    },
    __setExpiredAt(state, expiredAt) {
      state.expiredAt = expiredAt;
    },

    // REACTIONS — { byId, bySlug, list }
    __setReactions(state, maps) {
      state.reactions = maps || { byId: {}, bySlug: {}, list: [] };
    },
  },
  actions: {
    // 잔액 새로고침 (로그인 후, 가챠 차감 후 등)
    async loadCurrencyBalance({ commit }) {
      try {
        const balance = await CurrencyApi.fetchBalance();
        commit("__setCurrencyBalance", balance);
      } catch (e) {
        console.error("loadCurrencyBalance failed", e);
      }
    },
  },
  modules: {
    broadcast,
  },
});
